import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../../components/data-table-builder/data-table.types';
import { ContactRepository } from '../../../../store/contact-state/contact-state.repository';
import { CompanyContact, Contact } from '@/types';

interface getContactDataTableStructureProps {
  companyId?: number;
  store: ContactRepository;
  createAction?: () => void;
  rowActions?: DataTableRowActions;
}

export const getContactDataTableStructure = ({ companyId, store, createAction, rowActions }: getContactDataTableStructureProps): DynamicDataTable => {
  const idColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contact.table.id',
    accessorKey: companyId ? 'contact.id' : 'id',
    variant: DataTableColumnVariant.TEXT,
  };
  const nameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contact.table.name',
    accessorKey: companyId ? 'contact.nom' : 'nom',
    variant: DataTableColumnVariant.TEXT,
  };
  const addressColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contact.table.address',
    accessorKey: companyId ? 'contact.address' : 'address',
    variant: DataTableColumnVariant.TEXT,
  };
  const tel1Column: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contact.table.phoneOne',
    accessorKey: companyId ? 'contact.tel1' : 'tel1',
    variant: DataTableColumnVariant.TEXT,
  };
  const tel2Column: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contact.table.phoneTwo',
    accessorKey: companyId ? 'contact.tel2' : 'tel2',
    variant: DataTableColumnVariant.TEXT,
  };
  const emailColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contact.table.email',
    accessorKey: companyId ? 'contact.email' : 'email',
    variant: DataTableColumnVariant.TEXT,
  };
  const isLegalRepresentativeColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contact.table.legalRepresentation',
    accessorKey: companyId ? 'societeContact.representantLegal' : 'representantLegal',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: boolean) => {
      return value ? { value: 'Oui' } : { value: 'Non' };
    },
    props: {
      innerClass: 'px-3 py-1',
      getSeverity: (value: boolean) => {
        return value === true ? 'success' : 'danger';
      },
    },
  };
  const isPrincipalColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'settings.contact.table.principal',
    accessorKey: companyId ? 'societeContact.principal' : 'principal',
    variant: DataTableColumnVariant.BADGE,
    renderAs: (value: boolean) => {
      return value ? { value: 'Oui' } : { value: 'Non' };
    },
    props: {
      innerClass: 'px-3 py-1',
      getSeverity: (value: boolean) => {
        return value === true ? 'success' : 'danger';
      },
    },
  };
  return {
    singular: 'settings.contact.table.singular',
    plural: 'settings.contact.table.plural',
    columns: [idColumn, nameColumn, addressColumn, tel1Column, tel2Column, emailColumn, isLegalRepresentativeColumn, isPrincipalColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: (row: Contact | CompanyContact) => {
      if (companyId) {
        store.set('companyResponse', {
          contact: (row as CompanyContact).contact,
          societeContact: (row as CompanyContact).societeContact,
        });
        store.set('dto', (row as CompanyContact).contact);
        store.set('companyContactExtraDto', (row as CompanyContact).societeContact);
      } else {
        store.set('response', row);
        store.set('dto', {
          nom: (row as Contact).nom,
          address: (row as Contact).address,
          tel1: (row as Contact).tel1,
          tel2: (row as Contact).tel2,
          email: (row as Contact).email,
        });
      }
    },
    createAction,
    rowActions,
    searchableFields: [
      'contact.id',
      'contact.nom',
      'contact.address',
      'contact.tel1',
      'contact.tel2',
      'contact.email',
      'societeContact.representantLegal',
      'societeContact.principal',
    ],
  };
};
